'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (Component) {
  return Component.displayName || Component.name || 'Component';
};


//////////////////
// WEBPACK FOOTER
// ./~/react-jss/lib/getDisplayName.js
// module id = 1635
// module chunks = 231608221292675